import { LocalStorageKeys } from '../../../utilities/storageUtils';

// DEPRECATED: To be removed after 30-JUN-2026
// The preloadedStates parameter was used to reset specific keys on load.
// With inclusion-based persistence, fields not in inclusionList are never saved,
// so they get their INITIAL_STATE from reducers automatically.
export const loadState = (/* preloadedStates = {} */) => {
  try {
    const serializedState = localStorage.getItem(LocalStorageKeys.REDUX_LOCAL_STORAGE);
    if (serializedState === undefined || serializedState === null) {
      return undefined;
    }

    const jsonSerializedState = JSON.parse(serializedState);

    // DEPRECATED: Following set of commented lines are slated to be removed after 30-JUN-2026.
    // See comment block above loadState function for more detail on changes related to 'preloadedStatesDict' to avoid any confusion whatsoever.
    /*
    const preloadedStatesDict = Object.keys(preloadedStates).reduce((acc, key) => {
      return {
        ...acc,
        [key]: preloadedStates[key],
      };
    }, {});

    return {
      ...jsonSerializedState,
      ...preloadedStatesDict,
    };
    */

    return jsonSerializedState;
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state, inclusionList = []) => {
  try {
    const stateToSave = makeCopy(state, inclusionList);

    // Temporary debug console log to check if inclusionList works correctly.
    // To be removed after 30-JUN-2026
    /*
    console.log('[reduxLocalStorage] saveState', {
      currentState: state,
      inclusionList,
      stateToSavePostCopy: stateToSave
    });
    */

    const serializedState = JSON.stringify(stateToSave);
    localStorage.setItem(LocalStorageKeys.REDUX_LOCAL_STORAGE, serializedState);
  } catch {
    // ignore write errors
    return null;
  }
};

export const deleteState = () => {
  try {
    localStorage.removeItem(LocalStorageKeys.REDUX_LOCAL_STORAGE);
  } catch (err) {
    return null;
  }
};

const objConstrcutor = {}.constructor;
const dehydrateCopy = true;

const makeCopy = (src, inclusionList = [], srcKey = '') => {
  // Check if key should be included (only keys in inclusionList are saved)
  // - srcKey matches exactly one of the inclusion keys
  // - srcKey is a child of an inclusion key (e.g., srcKey='lodgeConfig.someProp' when inclKey='lodgeConfig')
  // - inclKey is a child of srcKey (need to traverse down to find the actual key)
  const isInInclusionList = inclusionList.some(
    inclKey => srcKey === inclKey || srcKey.startsWith(inclKey + '.') || inclKey.startsWith(srcKey + '.')
  );
  const shouldIncludeKey = srcKey.length === 0 || isInInclusionList;

  if (src != null && src !== undefined && shouldIncludeKey) {
    const isObject = src.constructor === objConstrcutor;

    if (isObject) {
      let copyObj = {};
      Object.keys(src).forEach(key => {
        const compositeKey = srcKey.length > 0 ? srcKey + '.' + key : key;

        const copiedVal = makeCopy(src[key], inclusionList, compositeKey);
        if (!dehydrateCopy || (copiedVal != null && copiedVal !== undefined)) {
          copyObj[key] = copiedVal;
        }
      });
      return !dehydrateCopy || Object.keys(copyObj).length > 0 ? copyObj : null;
    } else if (Array.isArray(src)) {
      const compositeKey = srcKey.length > 0 ? srcKey + '.[]' : '[]';

      const copiedVal = src
        .map(item => makeCopy(item, inclusionList, compositeKey))
        .filter(item => !dehydrateCopy || (item != null && item !== undefined));
      return !dehydrateCopy || copiedVal.length > 0 ? copiedVal : null;
    } else {
      return JSON.parse(JSON.stringify(src));
    }
  }
};
